import {Component, HostBinding, Input} from '@angular/core';

@Component({
  selector: 'pristine-nav-horizontal-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss']
})
export class pristineNavHorizontalItemComponent {
  @HostBinding('class')
  classes = 'nav-item';

  @Input()
  item: any;

  /**
   * Constructor
   */
  constructor() {

  }
}
